import React, { useEffect } from 'react';
import { APPLICATION_NAME, RODEO_PAGE_NAME } from 'src/_config';
import TermOfUsePage from 'src/components/cms/termOfUse/termOfUsePage';
import Sidebar from 'src/components/common/Sidebar';

export default function TermOfUseContainer() {

    useEffect(() => {
        const prevTitle = document.title
        document.title = `${APPLICATION_NAME} : Term Of Use`
        return () => {
            document.title = prevTitle
        }
    }, [])

    return (
        <React.Fragment>
            <Sidebar page={RODEO_PAGE_NAME.TERM_OF_USE} />
            <section className="main-container">
                <TermOfUsePage />
            </section>
        </React.Fragment>
    )
}